import { createContext } from '@lit/context';

export type MinMax = {
  min: { value: number, fmt: string };
  max: { value: number, fmt: string };
}

type Price = MinMax & {
  monthly: MinMax
}

type Discount = MinMax & {
  monthly   : MinMax,
  percentage: MinMax & {
    monthly: MinMax
  }
}

export type stateContextType = {
  price          : Price;
  discountedPrice: Price;
  discount       : Discount;
}
export const stateContext = createContext<stateContextType>(Symbol('state'));